


























import Vue from "vue";
import {
  DrillQuestionAndAnswers,
  DrillUserAnswer,
  ApiDrillPronunciation,
  DrillLearningStatus,
  DrillListeningAnswer,
  ApiDrillListening,
  ApiDrillListeningOption,
  RespDrillListeningAnswer
} from "@tt-app/models/exercise";
import { audioContext } from "@tt-app/utils/audio/audioContext";

import { AudioDecoderPlayer } from "@joyz/app-core/utils/audio";

import IconCardListening from "@joyz/app-core/assets/icons/transparent/DrillListening.svg";
import IconCorrect from "@joyz/app-core/assets/icons/Correct.svg";
import IconIncorrect from "@joyz/app-core/assets/icons/Incorrect.svg";
import IconSpeaker from "@joyz/app-core/assets/icons/default/Speaker.svg";
import IconSkipped from "@joyz/app-core/assets/icons/misc/DrillSkip.svg";

interface Data {
  icons: { [key: string]: string };
}

interface Methods {
  getCorrectnessIcon: (answer: DrillUserAnswer) => string;
  getLearnStatus: (learnStatus: DrillLearningStatus) => number;
  playWordAudio: (exercise: DrillQuestionAndAnswers) => void;
}

interface Computed {
  word: string;
}

interface Props {
  audioDecoderPlayer: AudioDecoderPlayer;
  exercise: DrillQuestionAndAnswers;
  questionIndex: number;
}

export default Vue.extend<Data, Methods, Computed, Props>({
  name: "DrillAnswerListening",

  props: {
    audioDecoderPlayer: { type: Object as () => AudioDecoderPlayer, required: true },
    exercise: { type: Object as () => DrillQuestionAndAnswers, required: true },
    questionIndex: { type: Number, required: true }
  },

  data() {
    return {
      icons: {
        drillType: IconCardListening,
        skipped: IconSkipped,
        speaker: IconSpeaker
      }
    };
  },

  computed: {
    word() {
      const options = (this.exercise.question as ApiDrillListening).options;
      const lastAnswer = this.exercise.lastAnswer;

      // Question was skipped
      if (!lastAnswer) {
        const skippedResp = this.exercise.skipped;
        if (!skippedResp) {
          return "## MISSING SkippedResponse ##";
        }

        const correctId = (skippedResp as RespDrillListeningAnswer).correctId;
        const correctOption: ApiDrillListeningOption | undefined = options.find(
          option => option.id === correctId
        );

        return correctOption
          ? correctOption.text
          : `## SkippedResponse correctId ${correctId} not found ##`;
      }

      const selectedId = (lastAnswer.submittedAnswer as DrillListeningAnswer).optionId;
      const selectedOption: ApiDrillListeningOption | undefined = options.find(
        option => option.id === selectedId
      );

      // WARNING! selected option not found
      if (!selectedOption) {
        return "## SELECTED OPTION NOT FOUND ##";
      }

      return selectedOption.text;
    }
  },

  methods: {
    getCorrectnessIcon(answer) {
      return answer.correction.isCorrect ? IconCorrect : IconIncorrect;
    },

    getLearnStatus(learnStatus) {
      return learnStatus !== null ? learnStatus : -1;
    },

    async playWordAudio(exercise) {
      const word = (exercise.question as ApiDrillPronunciation).word;
      const audio = word ? word.audio : undefined;

      if (audio) {
        if (this.audioDecoderPlayer.status === "playing") {
          this.audioDecoderPlayer.stop();
        }

        await audioContext.resume();
        await this.audioDecoderPlayer.play(audio);
      }
    }
  }
});
